<div class="shell">
  <nav-bar></nav-bar>
  <router-outlet></router-outlet>
</div>
